import GroupStudent from './GroupStudent';
export default GroupStudent;
